// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"14":"ecosystem","47":"validatorslots","170":"validator","773":"validatorform","961":"delegator"}[chunkId] + "." + {"14":"1310d7bb","47":"df85a252","170":"8fc777ae","773":"dfc5caff","961":"1dc52b97"}[chunkId] + ".css";
};